import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchData } from "../../features/dropdown/dropdownSlice";
import Search from "../../components/Search";
import careerSide from "../../assets/img/career-side-image.png";
import ndovuHr from "../../assets/img/ndovuPayShield.png";
import svg31 from "../../assets/svg/svg31.svg";
import svg104 from "../../assets/svg/svg104.svg";
import svg105 from "../../assets/svg/svg105.svg";
import { Dropdown } from "antd";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { clearAuthObj, setJobSeekerUser } from "../../features/auth/authSlice";
import toast from "react-hot-toast";

function CareerHeader({ searchInput, setsearchInput, hide }) {
  const url = "api/v1/jobs/getAll";
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { jobSeekeruser } = useSelector((state) => state.auth);
  const { tokenJobSeeker } = useSelector((state) => state.auth);
  const [localUser, setLocalUser] = useState(null);
  async function handleInit() {
    if (tokenJobSeeker && tokenJobSeeker?.split(".")?.length === 3) {
      const decoded = jwtDecode(tokenJobSeeker);
      setLocalUser(decoded);
      dispatch(setJobSeekerUser(decoded));
    }
  }

  const handleSearch = (e) => {
    setsearchInput(e.target.value);
    dispatch(
      fetchData({
        url: url,
        jobTitle: e.target.value == "" ? null : e.target.value,
      })
    );
  };
  const handleLanding = () => {
    window.location.href = "https://ndovuhr.com/home.action";
  };

  const handleLogout = async () => {
    await localStorage.clear();
    await dispatch(clearAuthObj());
    await navigate("/recruitment/career-list");
    window.location.reload();
  };
  const handleLogin = async () => {
    await navigate("/recruitment/login-seeker");
  };
  const items = [
    {
      label: (
        <>
          <div className="bg-white flex flex-col p-[1.25rem] min-w-[15.1875rem] h-auto ">
            <button
              onClick={handleLogout}
              className="flex items-center py-[.62rem] px-[1rem] mt-[.62rem]"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
              >
                <path
                  d="M7.5 13.5C7.5 13.6326 7.44732 13.7598 7.35355 13.8536C7.25979 13.9473 7.13261 14 7 14H3C2.86739 14 2.74021 13.9473 2.64645 13.8536C2.55268 13.7598 2.5 13.6326 2.5 13.5V2.5C2.5 2.36739 2.55268 2.24021 2.64645 2.14645C2.74021 2.05268 2.86739 2 3 2H7C7.13261 2 7.25979 2.05268 7.35355 2.14645C7.44732 2.24021 7.5 2.36739 7.5 2.5C7.5 2.63261 7.44732 2.75979 7.35355 2.85355C7.25979 2.94732 7.13261 3 7 3H3.5V13H7C7.13261 13 7.25979 13.0527 7.35355 13.1464C7.44732 13.2402 7.5 13.3674 7.5 13.5ZM14.3538 7.64625L11.8538 5.14625C11.7599 5.05243 11.6327 4.99972 11.5 4.99972C11.3673 4.99972 11.2401 5.05243 11.1462 5.14625C11.0524 5.24007 10.9997 5.36732 10.9997 5.5C10.9997 5.63268 11.0524 5.75993 11.1462 5.85375L12.7931 7.5H7C6.86739 7.5 6.74021 7.55268 6.64645 7.64645C6.55268 7.74021 6.5 7.86739 6.5 8C6.5 8.13261 6.55268 8.25979 6.64645 8.35355C6.74021 8.44732 6.86739 8.5 7 8.5H12.7931L11.1462 10.1462C11.0524 10.2401 10.9997 10.3673 10.9997 10.5C10.9997 10.6327 11.0524 10.7599 11.1462 10.8538C11.2401 10.9476 11.3673 11.0003 11.5 11.0003C11.6327 11.0003 11.7599 10.9476 11.8538 10.8538L14.3538 8.35375C14.4002 8.30731 14.4371 8.25217 14.4623 8.19147C14.4874 8.13077 14.5004 8.06571 14.5004 8C14.5004 7.93429 14.4874 7.86923 14.4623 7.80853C14.4371 7.74783 14.4002 7.69269 14.3538 7.64625Z"
                  fill="#212121"
                />
              </svg>
              <span className="profile_text ml-[.75rem]">Log out</span>
            </button>
          </div>
        </>
      ),
      key: "0",
    },
  ];

  useEffect(() => {
    handleInit();
  }, []);
  console.log("tokenJobSeeker", tokenJobSeeker);
  console.log("jobxSeekeruser", jobSeekeruser);
  return (
    <>
      <div className="career-pic lg:px-[22.5rem] px-3 rounded-t-[8px] pt-[2rem] flex flex-col ">
        <div className="flex lg:flex-row flex-col  gap-3 lg:items-center justify-between">
          <div
            className="text-[2rem] font-[500] font-dmSans flex items-center cursor-pointer w-fit text-white"
            onClick={handleLanding}
          >
            <img
              loading="lazy"
              decoding="async"
              src={ndovuHr}
              alt="logo"
              className="h-[7vh] object-contain "
            />
            Ndovu <span className="text-darkOrange ml-2">H</span>
            <span className="text-red1">R</span>
          </div>
          <div className="flex item-center gap-[3.31rem] text-[1.125rem] text-white font-[500]">
            <span className="cursor-pointer" onClick={handleLanding}>
              Home
            </span>
            <span>Careers</span>
          </div>
          {tokenJobSeeker ? (
            <div className="flex items-center gap-[1rem] ">
              <div className="seekerIcons">
                <img src={svg104} alt="svg104" />
              </div>

              <div className="seekerIcons">
                <img src={svg105} alt="svg105" />
              </div>

              <Dropdown
                menu={{
                  items,
                }}
                trigger={["click"]}
              >
                <div className="seekerIcons !w-auto !px-[1rem] text-white gap-1">
                  <img src={svg31} alt="svg31" />
                  <span>
                    {localUser?.usrFirstName || jobSeekeruser?.usrFirstName}{" "}
                  </span>
                </div>
              </Dropdown>
            </div>
          ) : (
            <button
              className=" border border-[#0B363D] rounded-[1.625rem] min-w-[8.0625rem] w-auto  min-h-[2.5rem] px-[.75rem] flex items-center justify-center bg-[#F9F9F9]"
              onClick={handleLogin}
            >
              Login
            </button>
          )}
        </div>

        <div className="flex flex-col-reverse lg:flex-row justify-between mt-6 gap-6">
          {!hide && (
            <>
              <div>
                <div className="text-[2rem] font-[500] text-white font-dmSans">
                  Ndovu HR Career Opportunities
                </div>
                <div className="text-[1.125rem] font-[500] font-dmSans text-white">
                  Welcome to a Future of Endless Possibilities
                </div>
                <div className="lg:w-[35.125rem] w-auto my-[2rem]">
                  <Search
                    searchInput={searchInput}
                    handleSearch={handleSearch}
                    text={"Search ..."}
                  />
                </div>
              </div>
              <div>
                <img
                  className="lg:w-[22.4375rem] w-auto h-[10rem] lg:h-auto self-center"
                  src={careerSide}
                  alt="careerSide"
                />
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default CareerHeader;
